import { createSelector } from '@reduxjs/toolkit';

import benefitsSelector from './benefits';

const benefitsEnableSelector = createSelector(
  benefitsSelector,
  benefits => benefits.enable,
);

export default benefitsEnableSelector;
